// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import { columnGap } from '../../styled-components/dark/helpers';
import BasketCombinationsHeader from '../BasketCombinationsHeader';
import BasketCombinationsSlider from '../BasketCombinationsSlider';
import RoundedButton from '../RoundedButton';

const Wrapper = styled.div`
  width: 100%;
`;

const colGap = columnGap(1);
const SliderWrapper = styled.div`
  margin: 0.25em 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  ${Target.__MOBILE__ ? colGap : ''}
`;

const StyledBasketCombinationsSlider = styled(BasketCombinationsSlider)`
  margin: 0;
  flex: 1000;
  position: relative;
  padding-top: 0.3em;

  ${({ $shadow }) =>
    $shadow
      ? css`
          &:after {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;

            box-shadow: inset -3em 0px 1.5em -1em ${theme.BasketFooter.backgroundColor};
            pointer-events: none;
          }
        `
      : null}
`;

const UpdateButton = styled(RoundedButton)`
  flex: 1;
  text-transform: uppercase;
  padding: 0 1em;
  font-size: 80%;
  height: 1.8em;
`;

type BasketCombinationsSummaryProps = BasketCombinationsSliderCellDataType & {
  className?: string;
  headerLabel: string;
  counter: number | null;
  combinations: Array<{ label: string; counter: number }>;
  onUpdateButtonClick: (...params: unknown) => unknown;
};

const BasketCombinationsSummary = ({
  className,
  headerLabel,
  counter,
  combinations,
  onUpdateButtonClick,
}: BasketCombinationsSummaryProps) => {
  return (
    <Wrapper className={className}>
      <BasketCombinationsHeader label={headerLabel} counter={counter} />
      <SliderWrapper>
        <StyledBasketCombinationsSlider
          className="system-combinations-slider"
          combinations={combinations}
          $shadow={Target.__MOBILE__ && combinations?.length > 1}
        />
        {onUpdateButtonClick ? (
          <UpdateButton
            backgroundColor={theme.BasketCombinationsSummary.updateButtonBackgroundColor}
            color={theme.BasketCombinationsSummary.updateButtonColor}
            label={combinations?.length === 0 ? __('Add') : __('Edit')}
            onClick={onUpdateButtonClick}
          />
        ) : null}
      </SliderWrapper>
    </Wrapper>
  );
};

export default BasketCombinationsSummary;
